import { ReactElement } from 'react';

import { TherapeuticGroupReceptionService } from '@dreryk/egabinet-group-session-frontend-api';

import { Text } from '@dreryk/react-components';

type ReceptionServiceCellProps = {
   readonly receptionService: TherapeuticGroupReceptionService;
};

export const ReceptionServiceCell = (props: ReceptionServiceCellProps): ReactElement => {
   return <Text testId={'receptionService'}>{props.receptionService.name}</Text>;
};
